import React from 'react';
import { Box } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useCustomer } from '../../../customHooks/CustomerContext';

const CustomBox = ({ value, selected, onClick }) => {
  return (
    <Box
      sx={{
        width: '30px',
        height: '30px',
        display: 'flex',
        border: `1px solid ${!selected ? '#DDDDDD' : '#FF7676'}`,
        p: 1,
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        backgroundColor: selected ? '#FF7676' : 'transparent',
        color: selected ? 'white' : '#FF7676',
      }}
      onClick={onClick}
    >
      {value}
    </Box>
  );
};

const Pagination = () => {
  const { linksAC, metaAC, setCurrentPageAC } = useCustomer();

  return (
    <Box sx={{ display: 'flex' }}>
      {linksAC?.prev && (
        <CustomBox
          value={<KeyboardArrowLeftIcon />}
          onClick={() => {
            setCurrentPageAC(metaAC?.current_page - 1);
          }}
        />
      )}
      {linksAC?.prev && (
        <CustomBox
          value={metaAC?.current_page - 1}
          onClick={() => {
            setCurrentPageAC(metaAC?.current_page - 1);
          }}
        />
      )}
      <CustomBox value={metaAC?.current_page} selected={true} />
      {linksAC?.next && (
        <CustomBox
          value={metaAC?.current_page + 1}
          onClick={() => {
            setCurrentPageAC(metaAC?.current_page + 1);
          }}
        />
      )}
      {linksAC?.next && (
        <CustomBox
          value={<KeyboardArrowRightIcon />}
          onClick={() => {
            setCurrentPageAC(metaAC?.current_page + 1);
          }}
        />
      )}
    </Box>
  );
};

export default Pagination;
